// eslint-disable-next-line import/prefer-default-export
export const SET_SPEAKER_EVENT = 'CONGRESS_ADMINISTRATOR/SET_SPEAKER_EVENT'
export const SET_EVENTS = 'CONGRESS_ADMINISTRATOR/SET_EVENTS'
export const SET_SPEAKERS = 'CONGRESS_ADMINISTRATOR/SET_SPEAKERS'
export const SET_STATISTICS = 'CONGRESS_ADMINISTRATOR/SET_STATISTICS'
